import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('submitting');
    setFormMessage('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotValue = (formData.get('website_alt') as string || '').trim();
    if (honeypotValue) {
      setFormStatus('success');
      setFormMessage('感谢您的留言，我们会尽快回复！');
      form.reset();
      return;
    }

    formData.delete('website_alt');

    try {
      const response = await fetch('http://kanpian51.cn/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormMessage('感谢您的留言，我们会尽快回复！');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后再试';
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setFormStatus('error');
          setFormMessage('提交失败，请稍后再试');
        } else {
          setFormStatus('error');
          setFormMessage(serverMsg);
        }
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <>
      <Navbar />
      <main>
        {/* Breadcrumb */}
        <div className="pt-20 pb-4 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
          </div>
        </div>

        {/* Hero Banner */}
        <section className="relative h-[300px] md:h-[400px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20cozy%20office%20space%20with%20warm%20ambient%20lighting%2C%20wooden%20desk%20with%20laptop%20and%20coffee%2C%20plant%20decor%2C%20creative%20workspace%20atmosphere%2C%20warm%20orange%20and%20cream%20tones%2C%20lifestyle%20photography%2C%20clean%20composition&width=1800&height=600&seq=about-hero-51chigua&orientation=landscape"
            alt="51吃瓜网站——关于我们"
            title="51吃瓜网站品牌介绍"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
          <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
            <h1 className="text-3xl md:text-5xl font-heading text-background-50 font-black mb-3">
              关于51吃瓜
            </h1>
            <p className="text-white/60 text-sm md:text-base max-w-lg">
              一群热爱吃瓜的资深网友，用心打造最全娱乐八卦平台
            </p>
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-6">
              品牌介绍
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                <strong>51吃瓜网站</strong>成立于2024年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为吃瓜群众提供最新、最全、最真实的网红明星八卦、黑料爆料和娱乐资讯。
              </p>
              <p>
                在这个信息爆炸的时代，娱乐圈的瓜层出不穷。明星塌房、网红翻车、综艺名场面……每一天都有新鲜的热点话题。然而，面对海量信息，普通网友往往难以分辨真假，也难以高效地获取自己关心的内容。
              </p>
              <p>
                正是基于这一痛点，51吃瓜网站应运而生。我们聚合了来自全网的最新爆料和吃瓜内容，通过专业的编辑团队进行筛选和整理，确保每一条资讯都经过核实，为读者提供高质量的阅读体验。
              </p>
              <p>
                我们的团队由一群热爱吃瓜、熟悉互联网文化的资深网友组成。核心成员来自知名互联网公司和媒体平台，拥有丰富的内容运营和技术开发经验。我们坚持<strong>"吃瓜不站队，理性看热闹"</strong>的原则，致力于打造一个公正、客观、有趣的娱乐八卦平台。
              </p>
              <p>
                目前，51吃瓜网站已覆盖<strong>网红八卦、明星塌房、黑料爆料、综艺吃瓜、影视八卦、互联网瓜</strong>等六大核心频道，每日更新超过50篇高质量内容，累计服务超过百万吃瓜用户。
              </p>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-14 md:py-16 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
              <div>
                <p className="text-3xl md:text-4xl font-heading font-black text-accent-500">100w+</p>
                <p className="text-sm text-foreground-500 mt-1">吃瓜用户</p>
              </div>
              <div>
                <p className="text-3xl md:text-4xl font-heading font-black text-accent-500">5000+</p>
                <p className="text-sm text-foreground-500 mt-1">累计爆料</p>
              </div>
              <div>
                <p className="text-3xl md:text-4xl font-heading font-black text-accent-500">50+</p>
                <p className="text-sm text-foreground-500 mt-1">日均更新</p>
              </div>
              <div>
                <p className="text-3xl md:text-4xl font-heading font-black text-accent-500">99.7%</p>
                <p className="text-sm text-foreground-500 mt-1">用户好评率</p>
              </div>
            </div>
          </div>
        </section>

        {/* User Reviews / Reputation */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-2">
              用户口碑
            </h2>
            <p className="text-sm text-foreground-500 mb-8">听听吃瓜群众怎么说</p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {[
                {
                  name: '吃瓜群众小王',
                  comment: '自从发现了51吃瓜，每天通勤路上第一件事就是打开刷一遍，比刷微博有意思多了！总结得特别到位，省去了我自己到处找瓜的时间。',
                  date: '2026-06-28',
                  rating: 5,
                },
                {
                  name: '娱乐圈观察家',
                  comment: '内容质量很高，编辑团队显然很专业。不是那种随便搬运的低质量内容，每篇都有深度分析和独家角度，值得推荐给所有吃瓜爱好者。',
                  date: '2026-06-25',
                  rating: 5,
                },
                {
                  name: '理性吃瓜人',
                  comment: '难得看到一个不站队的瓜田。很多平台的吃瓜内容都带有明显的立场倾向，但51吃瓜基本保持了客观中立，这点很难得。',
                  date: '2026-06-20',
                  rating: 4,
                },
                {
                  name: '互联网冲浪选手',
                  comment: '更新速度是真的快！每次有大瓜爆出来，第一时间就能在这里看到全面的整理和分析。已经推荐给身边所有朋友了。',
                  date: '2026-06-15',
                  rating: 5,
                },
              ].map((review, idx) => (
                <div key={idx} className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center gap-1 mb-2">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${
                          i < review.rating
                            ? 'ri-star-fill text-accent-500'
                            : 'ri-star-line text-foreground-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    &ldquo;{review.comment}&rdquo;
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span className="font-medium text-foreground-600">{review.name}</span>
                    <span>{review.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-8 text-center">
              常见问题
            </h2>

            <div className="space-y-3">
              {[
                {
                  q: '51吃瓜网站的内容来源是什么？',
                  a: '我们的内容来源于全网公开的社交媒体平台、新闻报道、网友投稿等多个渠道。所有内容均经过编辑团队核实和整理后发布，确保信息的真实性和可读性。',
                },
                {
                  q: '如何下载51吃瓜APP？',
                  a: '您可以在本网站首页点击"立即下载APP"按钮，或在各大应用商店搜索"51吃瓜"进行下载。我们提供iOS和Android两个版本的APP。',
                },
                {
                  q: '51吃瓜网站是免费的吗？',
                  a: '是的，51吃瓜网站所有内容完全免费。我们致力于让每一位吃瓜群众都能无障碍地获取最新最全的娱乐八卦资讯。',
                },
                {
                  q: '如何向我们投稿爆料？',
                  a: '您可以通过页面下方的联系表单提交您的爆料线索，也可以通过我们的官方社交媒体账号私信。我们会对所有投稿严格保密。',
                },
                {
                  q: '如果发现内容有误，如何反馈？',
                  a: '您可以通过联系表单或社交媒体渠道向我们反馈。我们非常重视内容的准确性，会在收到反馈后第一时间核实并更正。',
                },
              ].map((faq, idx) => (
                <details key={idx} className="group bg-background-50 rounded-lg">
                  <summary className="px-5 py-4 cursor-pointer flex items-center justify-between text-sm md:text-base font-medium text-foreground-950 hover:text-accent-600 transition-colors">
                    {faq.q}
                    <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform text-foreground-400"></i>
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-2xl mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-2 text-center">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 mb-8 text-center">
              有任何问题、建议或爆料线索，欢迎给我们留言
            </p>

            <form
              id="contact-form-about"
             
              onSubmit={handleSubmit}
              className="space-y-4"
            >
              {/* Honeypot */}
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    姓名
                  </label>
                  <input
                    id="contact-name"
                    name="name"
                    type="text"
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200 rounded-lg text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-accent-400 transition-colors"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    邮箱
                  </label>
                  <input
                    id="contact-email"
                    name="email"
                    type="email"
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200 rounded-lg text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-accent-400 transition-colors"
                    placeholder="请输入您的邮箱"
                  />
                </div>
              </div>
              <div>
                <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  主题
                </label>
                <select
                  id="contact-subject"
                  name="subject"
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200 rounded-lg text-foreground-950 focus:outline-none focus:border-accent-400 transition-colors appearance-none cursor-pointer"
                >
                  <option value="">请选择主题</option>
                  <option value="爆料投稿">爆料投稿</option>
                  <option value="内容反馈">内容反馈</option>
                  <option value="合作咨询">合作咨询</option>
                  <option value="其他问题">其他问题</option>
                </select>
              </div>
              <div>
                <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  留言内容
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  required
                  rows={5}
                  maxLength={500}
                  className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200 rounded-lg text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-accent-400 transition-colors resize-none"
                  placeholder="请输入您的留言（500字以内）"
                ></textarea>
              </div>

              {formStatus === 'success' && (
                <div className="bg-accent-100/50 border border-accent-200 text-accent-800 text-sm px-4 py-3 rounded-lg">
                  {formMessage}
                </div>
              )}
              {formStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3 rounded-lg">
                  {formMessage}
                </div>
              )}

              <button
                type="submit"
                disabled={formStatus === 'submitting'}
                className="w-full bg-primary-500 text-background-50 py-3 rounded-lg font-medium text-sm hover:bg-primary-600 disabled:opacity-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                {formStatus === 'submitting' ? '提交中...' : '发送留言'}
              </button>
            </form>
          </div>
        </section>
      </main>

      {/* Schema.org AboutPage + FAQPage */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于51吃瓜网站',
            description: '51吃瓜网站是国内领先的娱乐八卦资讯聚合平台，致力于为吃瓜群众提供最新、最全、最真实的网红明星八卦资讯。',
            url: 'http://kanpian51.cn/about',
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'http://kanpian51.cn/',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: '关于我们',
                },
              ],
            },
            mainEntity: {
              '@type': 'FAQPage',
              mainEntity: [
                {
                  '@type': 'Question',
                  name: '51吃瓜网站的内容来源是什么？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '我们的内容来源于全网公开的社交媒体平台、新闻报道、网友投稿等多个渠道。所有内容均经过编辑团队核实和整理后发布。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '如何下载51吃瓜APP？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '您可以在本网站首页点击"立即下载APP"按钮，或在各大应用商店搜索"51吃瓜"进行下载。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '51吃瓜网站是免费的吗？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '是的，51吃瓜网站所有内容完全免费。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '如何向我们投稿爆料？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '您可以通过联系表单提交您的爆料线索，也可以通过我们的官方社交媒体账号私信。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '如果发现内容有误，如何反馈？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '您可以通过联系表单或社交媒体渠道向我们反馈，我们会在收到反馈后第一时间核实并更正。',
                  },
                },
              ],
            },
          }),
        }}
      />

      <Footer />
    </>
  );
}